import * as React from "react";
import { Chip } from "common";
import { Flex, Loading, SmallTile } from "lqx-react";
import { CustomerProfileLandingSummary } from "../../api/customer-profile";
import { WidgetSmallLoading } from "../../common";
import { PendingNewRelationships } from "./new-relationships";

export const TodoTiles = ({ $category, model }: { $category, model: CustomerProfileLandingSummary }) =>
    <>
        <SmallTile
            color="red"
            $selected={$category.equals('new-relationship')}
            right={<Chip color="red">{model.isTodoReady ? model.totalNewRelationships : <WidgetSmallLoading />}</Chip>}
            footer="New relationships to be set up within the Customer Profile"
        >
            New Relationship
        </SmallTile>
    </>

export const TodoDetails = ({ category, model }: { category: string, model: CustomerProfileLandingSummary }) => {
    return (
        model.isTodoReady ?
            category === 'new-relationship'
                ? <PendingNewRelationships relationships={model.newRelationships} />
                : <Flex center> <h2>Select the category on the left</h2> </Flex>
            : <Loading />
    )
}
